module.exports = __webpack_public_path__ + "static/portico_01-265f8d5633a58892bf91a4436020c4ca.jpg";